import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showContact, setShowContact] = useState(false);
  return <footer className="py-[36px] md:py-[64px] px-5 bg-[#0F2340]" data-id="element-95">
      <div className="max-w-3xl mx-auto flex flex-col items-center gap-6" data-id="element-96">
        {/* Links */}
        <div className="flex flex-wrap justify-center gap-4 text-gray-400 text-sm" data-id="element-97">
          <button onClick={() => {
          setShowTerms(!showTerms);
          setShowPrivacy(false);
        }} className="hover:text-white transition-colors flex items-center gap-1" data-id="element-98">
            Términos y Condiciones
            <ChevronDownIcon className={`w-3.5 h-3.5 transition-transform duration-300 ${showTerms ? 'rotate-180' : ''}`} data-id="element-99" />
          </button>
          <span className="text-gray-600" data-id="element-100">|</span>
          <button onClick={() => {
          setShowPrivacy(!showPrivacy);
          setShowTerms(false);
        }} className="hover:text-white transition-colors flex items-center gap-1" data-id="element-101">
            Política de Privacidad
            <ChevronDownIcon className={`w-3.5 h-3.5 transition-transform duration-300 ${showPrivacy ? 'rotate-180' : ''}`} data-id="element-102" />
          </button>
          <span className="text-gray-600" data-id="element-103">|</span>
          <button onClick={() => {
          setShowContact(!showContact);
          setShowTerms(false);
          setShowPrivacy(false);
        }} className="hover:text-white transition-colors flex items-center gap-1.5" data-id="element-104">
            <MailIcon className="w-3.5 h-3.5" data-id="element-105" />
            Contacto
            <ChevronDownIcon className={`w-3.5 h-3.5 transition-transform duration-300 ${showContact ? 'rotate-180' : ''}`} data-id="element-106" />
          </button>
        </div>

        {/* Expandable Terms */}
        <AnimatePresence initial={false} data-id="element-107">
          {showTerms && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="w-full overflow-hidden" data-id="element-108">
              <div className="bg-[#1A3A5C] rounded-lg p-5 md:p-6 text-gray-300 text-sm leading-relaxed space-y-3" data-id="element-109">
                <h3 className="text-white font-bold text-base mb-3" data-id="element-110">
                  Términos y Condiciones
                </h3>
                <p data-id="element-111">
                  Al adquirir el producto digital "Mesas Epoxi Pro", el
                  comprador acepta los siguientes términos:
                </p>
                <p data-id="element-112">
                  <strong className="text-gray-200" data-id="element-113">Producto digital:</strong>{' '}
                  Se trata de un ebook en formato PDF de descarga inmediata. No
                  se realizan envíos físicos.
                </p>
                <p data-id="element-114">
                  <strong className="text-gray-200" data-id="element-115">Acceso:</strong> El link de
                  descarga se envía al email proporcionado al momento de la
                  compra. El acceso es de por vida y para uso personal.
                </p>
                <p data-id="element-116">
                  <strong className="text-gray-200" data-id="element-117">Garantía:</strong> Ofrecemos
                  7 días de garantía desde la fecha de compra. Si el producto no
                  cumple con lo prometido, se realiza la devolución del 100% del
                  dinero sin preguntas.
                </p>
                <p data-id="element-118">
                  <strong className="text-gray-200" data-id="element-119">
                    Propiedad intelectual:
                  </strong>{' '}
                  Todo el contenido del ebook es propiedad de Mesas Epoxi Pro.
                  Queda prohibida su reproducción, distribución o reventa sin
                  autorización.
                </p>
                <p data-id="element-120">
                  <strong className="text-gray-200" data-id="element-121">Pagos:</strong> Los pagos se
                  procesan de forma segura a través de Mercado Pago. Aceptamos
                  tarjetas de crédito, débito, transferencia bancaria y redes de
                  cobranza (Abitab, RedPagos).
                </p>
                <p data-id="element-122">
                  Para consultas:{' '}
                  <a href="mailto:joyasconresina44@gmail.com" className="text-[#C9A84C] hover:underline" data-id="element-123">
                    joyasconresina44@gmail.com
                  </a>
                </p>
              </div>
            </motion.div>}
        </AnimatePresence>

        {/* Expandable Privacy */}
        <AnimatePresence initial={false} data-id="element-124">
          {showPrivacy && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="w-full overflow-hidden" data-id="element-125">
              <div className="bg-[#1A3A5C] rounded-lg p-5 md:p-6 text-gray-300 text-sm leading-relaxed space-y-3" data-id="element-126">
                <h3 className="text-white font-bold text-base mb-3" data-id="element-127">
                  Política de Privacidad
                </h3>
                <p data-id="element-128">
                  En Mesas Epoxi Pro nos comprometemos a proteger tu información
                  personal.
                </p>
                <p data-id="element-129">
                  <strong className="text-gray-200" data-id="element-130">
                    Datos que recopilamos:
                  </strong>{' '}
                  Nombre, dirección de email y datos de pago necesarios para
                  procesar tu compra. No almacenamos datos de tarjetas de
                  crédito; estos son gestionados directamente por Mercado Pago.
                </p>
                <p data-id="element-131">
                  <strong className="text-gray-200" data-id="element-132">Uso de los datos:</strong>{' '}
                  Tu información se utiliza únicamente para enviar el producto
                  adquirido y comunicaciones relacionadas con tu compra. No
                  compartimos ni vendemos tus datos a terceros.
                </p>
                <p data-id="element-133">
                  <strong className="text-gray-200" data-id="element-134">Emails:</strong> Podés
                  recibir emails relacionados con tu compra y actualizaciones
                  del producto. Podés darte de baja en cualquier momento.
                </p>
                <p data-id="element-135">
                  <strong className="text-gray-200" data-id="element-136">Seguridad:</strong>{' '}
                  Utilizamos encriptación SSL y procesamos pagos a través de
                  Mercado Pago, que cumple con los estándares de seguridad PCI
                  DSS.
                </p>
                <p data-id="element-137">
                  Para solicitar la eliminación de tus datos o cualquier
                  consulta:{' '}
                  <a href="mailto:joyasconresina44@gmail.com" className="text-[#C9A84C] hover:underline" data-id="element-138">
                    joyasconresina44@gmail.com
                  </a>
                </p>
              </div>
            </motion.div>}
        </AnimatePresence>

        {/* Expandable Contact */}
        <AnimatePresence initial={false} data-id="element-139">
          {showContact && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="w-full overflow-hidden" data-id="element-140">
              <div className="bg-[#1A3A5C] rounded-lg p-5 md:p-6 text-gray-300 text-sm leading-relaxed text-center" data-id="element-141">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-142">
                  Contacto
                </h3>
                <p data-id="element-143">
                  ¿Dudas? Escribinos a{' '}
                  <a href="mailto:joyasconresina44@gmail.com" className="text-[#C9A84C] hover:underline font-semibold" data-id="element-144">
                    joyasconresina44@gmail.com
                  </a>
                </p>
                <p className="text-gray-400 mt-2 text-xs" data-id="element-145">
                  Respondemos en menos de 24 horas.
                </p>
              </div>
            </motion.div>}
        </AnimatePresence>

        <p className="text-gray-500 text-sm" data-id="element-146">
          © 2026 Mesas Epoxi Pro — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}